module.exports = __webpack_public_path__ + "officialStatic/img/szf.55f6aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/szf.png
// module id = /foK
// module chunks = 0